/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useStateContext } from '../../../contexts/ContextProvider';
import { Container, Modal } from 'reactstrap';
import { AlertCircle, AlertTriangle, CheckCircle, Plus, Shield, TrendingUp, Users } from 'react-feather';
import Grid from '@mui/material/Grid';

function NewReportsModal() {
  const { primary } = useStateContext();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const links = [
    {
      label: 'Whistleblowing',
      url: 'https://tinyurl.com/228z657z',
      icon: Shield,
    },
    {
      label: 'Incident reporting',
      url: 'https://tinyurl.com/IncidentReportingDomus',
      icon: AlertTriangle,
    },
    {
      label: 'Incidente informatico NIS2',
      url: 'https://tinyurl.com/IncInfNIS2',
      icon: CheckCircle,
    },
    {
      label: 'Proposta di miglioramento',
      url: 'https://tinyurl.com/Proposta-Miglioramento',
      icon: TrendingUp,
    },
    {
      label: 'Violazione dati GDPR',
      url: 'https://tinyurl.com/ViolazioneGDPR',
      icon: AlertCircle,
    },
    {
      label: 'Segnalazione Parità di Genere - UNI PdR 125',
      url: 'https://domusvestra.my.qualibus.it/Qualibus/Qualibus.htm?CMD=startEventoWizard&INFO=AD956483-7665-FF84-B79F-1A42B426F84F',
      icon: Users,
    }
  ];

  return (
    <>
      <Button
        variant="contained"
        type="button"
        onClick={handleOpen}
        startIcon={<Plus size={18} />}
        sx={{
          backgroundColor: primary,
          '&:hover': { backgroundColor: primary, filter: 'brightness(0.92)' },
        }}
      >
        Apri nuova segnalazione
      </Button>
      <Modal
        isOpen={open}
        toggle={handleClose}
        centered
        backdropClassName={open ? 'BDModalOpen' : 'BDModalClosed'}
        modalClassName={open ? 'ModalOpen' : 'ModalClosed'}
        size='lg'
      >
        <Container fluid={true} style={{ padding: '24px' }}>
          <Stack direction="row" spacing={1.5} alignItems="center" style={{ marginBottom: 12 }}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 2,
                display: 'grid',
                placeItems: 'center',
                backgroundColor: `${primary}20`,
              }}
            >
              <Plus size={18} color={primary} />
            </Box>
            <Box>
              <Typography variant="h6" sx={{ lineHeight: 1.1, margin: 0 }}>
                Apri nuova segnalazione
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Scegli la tipologia e verrai reindirizzato al modulo.
              </Typography>
            </Box>
          </Stack>

          <Grid container spacing={2}>
            {links.map((link) => {
              const Icon = link.icon ?? Shield;
              return (
                <Grid item xs={12} sm={6} md={3} key={link.label}>
                  <Button
                    component="a"
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    type="button"
                    fullWidth
                    startIcon={<Icon size={18} />}
                    sx={{
                      backgroundColor: primary,
                      color: '#fff',
                      textTransform: 'none',
                      justifyContent: 'flex-start',
                      paddingY: 1.1,
                      paddingX: 1.5,
                      borderRadius: 2,
                      boxShadow: 'none',
                      '& .MuiButton-startIcon': { color: 'inherit' },
                      '&:hover': {
                        backgroundColor: primary,
                        color: '#fff',
                        filter: 'brightness(0.92)',
                        boxShadow: '0 10px 22px rgba(0,0,0,0.12)',
                        transform: 'translateY(-1px)',
                      },
                      transition: 'transform 140ms ease, box-shadow 140ms ease, filter 140ms ease',
                    }}
                  >
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                        {link.label}
                      </Typography>
                    </Box>
                  </Button>
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </Modal>
    </>
  );
}

export default NewReportsModal;
